export function BorderText({ children, color = 'secondary', borderWidth = '4px' }: { children: React.ReactNode, color?: 'primary' | 'secondary' | 'background', borderWidth?: string }) {
  return (
    <span
      style={{
        WebkitTextStrokeWidth: borderWidth,
        WebkitTextStrokeColor: `var(--${color})`,
        color: 'transparent',
      }}
    > 
      {children}
    </span>
  );
}